import firebase from "firebase/app";
import "firebase/auth";
import Vue from "vue";
import config from "../config";
import moment from "moment";
import axios from "axios";
import { createProvider } from "../apolloConfiguration";
import {
  ADD_ERROR_LOG,
  CHECK_ACCESS_RIGHTS,
  LIST_CUSTOM_GROUPS,
  GET_PRESIGNED_URL,
  GET_EMPLOYEE_LIST,
  DELETE_PRESIGNED_URL,
  GET_ALL_EMPLOYEES,
  TRIGGER_CONTROLLER_FUNCTION,
  RETRIEVE_DROPDOWN_DETAILS,
  LIST_COUNTRY,
  IMPERSONATE_USER,
  ADD_SYSTEM_LOGS,
} from "@/graphql/commonQueries";
import { ADD_CUSTOM_GROUP } from "@/graphql/core-hr/customGroupQueries.js";
import {
  GET_ORGANIZATION_SUBSCRIPTION_DETAILS,
  GET_STATES,
} from "@/graphql/billing/billingQueries";
import {
  getErrorCodesWithValidationFromMessage,
  getErrorCodesAndMessagesWithValidation,
  getErrorCodes,
  handleNetworkErrors,
  encryptObject,
  extractNumberFromString,
} from "@/helper";
import {
  GET_SUBSCRIBED_PLAN_TYPE,
  ENCRYPT_REFRESH_TOKEN,
  LOGOUT_ENTOMO,
} from "@/graphql/layout/layoutQueries.js";

export default {
  //*Get user Ip address
  async fetchUserIp({ commit }) {
    var userIpAddress = "";
    await Vue.prototype.$http
      .get(config.ipAddressApi)
      .then((res) => {
        userIpAddress = res.data.ip;
        window.$cookies.set("userIpAddress", userIpAddress);
      })
      .catch(() => {
        userIpAddress = "";
      });
    commit("UPDATE_USER_IP_ADDRESS", userIpAddress);
  },

  //clear form lock if it set for any of the form user worked
  clearUserLock({ commit, dispatch, getters, state }) {
    // 401s from in-flight queries re-enter here; guard makes logout one-shot.
    if (state.logoutInProgress) return;

    // also the guard above; full-page loader stays up until location.replace
    commit("LOGOUT_IN_PROGRESS", true);
    // POST not GET: CloudFront cached the GET. catch first so userLogout throws can't re-enter.
    dispatch("triggerControllerFunction", {
      url: getters.baseUrl + "auth/index/clear-session-throw-lock",
      type: "POST",
      dataType: "json",
    })
      .catch(() => {})
      .then(() => dispatch("userLogout"));
  },

  handleApiErrors({ dispatch, commit }, payload) {
    return new Promise((resolve) => {
      const { error, action, form, isListError } = payload;
      console.error("error", error);
      console.error("error.message", error.message);
      console.error("error.graphQLErrors", error.graphQLErrors);
      let errorMessage = `Something went wrong while ${action} the ${form}.`;
      let secondMsg = " Please try after some time.";
      if (error && error.graphQLErrors && error.graphQLErrors.length > 0) {
        // error capture
        var errorCode = getErrorCodesAndMessagesWithValidation(error);
        if (errorCode && errorCode.length > 0) {
          switch (errorCode[0]) {
            case "_DB0000": // Technical error
              errorMessage =
                "It’s us! There seems to be some technical difficulties. Please try after some time - _DB0000";
              break;
            case "_DB0100": // This employee do not have view access rights
              errorMessage =
                "Sorry, you don't have view access rights. Please contact the HR administrator - _DB0100";
              break;
            case "_DB0102": // update access denied
              errorMessage =
                "Sorry, you don't have update access rights. Please contact the HR administrator - _DB0102";
              break;
            case "_DB0103": // delete access denied
              errorMessage =
                "Sorry, you don't have delete access rights. Please contact the HR administrator - _DB0103";
              break;
            case "_DB0101": // add access denied
              errorMessage =
                "Sorry, you don't have add access rights. Please contact the HR administrator - _DB0101";
              break;
            case "_DB0111":
              var formAccess = action === "adding" ? "add" : "update";
              errorMessage =
                "Sorry, you don't have " +
                formAccess +
                " access rights. Please contact the HR administrator - DB0111";
              break;
            case "_UH0001": // unhandled error
              errorMessage =
                errorMessage +
                " If you continue to see this issue please contact the platform administrator - _UH0001";
              break;
            case "ESS0126":
            case "IO0135":
              var failedData = [];
              if (
                error &&
                error.graphQLErrors &&
                error.graphQLErrors.length > 0
              ) {
                var firstError = error.graphQLErrors[0];

                if (firstError.extensions && firstError.extensions.failedData) {
                  failedData = firstError.extensions.failedData;
                }
              }
              if (errorCode[0] !== "IO0135") {
                errorMessage = errorCode[1] + " - " + errorCode[0];
              } else {
                errorMessage = null;
              }
              resolve(failedData);
              break;
            case "BAD_USER_INPUT":
              if (errorCode[2]) {
                errorMessage = "";
                resolve(errorCode[2]);
              }
              break;
            case "INTERNAL_SERVER_ERROR":
              var eMsg = "",
                eCode = "",
                vError = "";
              try {
                var parsedObj = JSON.parse(errorCode[1]); // Parse the JSON
                eMsg = parsedObj.message || errorCode[1]; // Return the message property or the original string
                eCode = parsedObj.errorCode;
                vError = parsedObj.validationError;
              } catch {
                eMsg = errorCode[1]; // Return the original string if there's an error
                eCode = "";
                vError = "";
              }
              if (eMsg) {
                if (eMsg.toLowerCase() === "invalid input request" && vError) {
                  const errorArray = Object.values(vError);
                  errorMessage = "";
                  resolve(errorArray);
                } else {
                  errorMessage = eMsg;
                }
                if (eCode) {
                  errorMessage = errorMessage + " - " + eCode;
                }
              } else {
                errorMessage = errorMessage + secondMsg;
              }
              break;
            default:
              errorMessage = errorCode[1] + " - " + errorCode[0];
              break;
          }
        } else {
          errorMessage = errorMessage + secondMsg;
        }
      } else if (error && error.message) {
        // 500/400 series errors
        let eCode = extractNumberFromString(error.message);
        eCode = eCode.toString();
        if (eCode === "502" || eCode === "504") {
          errorMessage =
            "Sorry, there was a problem processing your request due to a temporary issue. If the problem persists, feel free to contact our support team for assistance" +
            " - " +
            eCode;
        } else if (eCode === "400") {
          errorMessage =
            `Oops! We encountered a problem while ${action} the ${form}. Please contact the platform administrator.` +
            " - " +
            eCode;
        } else if (eCode === "401") {
          dispatch("clearUserLock");
        } else {
          errorMessage = errorMessage + secondMsg + " - " + eCode;
        }
      } else {
        errorMessage = errorMessage + secondMsg;
      }
      if (errorMessage) {
        if (isListError) {
          resolve(errorMessage);
        } else {
          let snackbarData = {
            isOpen: true,
            message: errorMessage,
            type: "warning",
          };
          commit("OPEN_SNACKBAR", snackbarData);
        }
      }
    });
  },

  //*Logout Current User from firebase
  userLogout({ dispatch }) {
    let partnerid = window.$cookies.get("partnerid");
    if (partnerid && partnerid.toLowerCase() === "entomo") {
      const {
        clients: { apolloClientH },
      } = createProvider();
      return new Promise(() => {
        apolloClientH
          .mutate({
            mutation: LOGOUT_ENTOMO,
            variables: {
              xAuthToken: window.$cookies.get("accessToken"),
            },
          })
          .then((response) => {
            if (response.data.logoutFromEntomo) {
              dispatch("clearUserSession");
            } else {
              dispatch("clearUserSession");
            }
          })
          .catch(() => {
            dispatch("clearUserSession");
          });
      });
    } else {
      const firebaseCurrentUser = firebase.auth().currentUser;
      if (firebaseCurrentUser) {
        firebase
          .auth()
          .signOut()
          .then(() => {
            dispatch("clearUserSession");
          })
          .catch(() => {
            dispatch("clearUserSession");
          });
      } else {
        dispatch("clearUserSession");
      }
    }
  },

  // restore store to default value on logout
  clearUserSession({ commit, getters }) {
    commit("RESTORE_DEFAULT_STATE");
    localStorage.clear();
    window.$cookies.remove("empUid");
    window.$cookies.remove("accessToken");
    window.$cookies.remove("refreshToken");
    window.$cookies.remove("userIpAddress");
    location.replace(getters.baseUrl + "auth");
  },

  // action to retrieve tax amount based on new and old tax regime
  retrieveTaxRegimeAmount({ dispatch, commit, getters }) {
    return new Promise((resolve, reject) => {
      Vue.prototype.$http
        .post(getters.baseUrl + "payroll/tax-rules/compare-tax-regime", {
          requestResource: "HRAPPUI",
        })
        .then((result) => {
          let regimeResonseData = result.data;
          if (regimeResonseData && regimeResonseData.success) {
            var regimeDetails = regimeResonseData.regimeComparisionDetails;
            commit("UPDATE_TAX_COMPARISON_DETAILS", regimeDetails);
            //check whether want to show compare tax regime alert or not
            if (
              regimeDetails &&
              regimeDetails.Trigger_Regime_Change &&
              regimeDetails.Total_Income > 0
            ) {
              commit("SHOW_TAX_REGIME_SELECTION_OPTION", true);
            } else {
              commit("SHOW_TAX_REGIME_SELECTION_OPTION", false);
            }
          } else {
            //on error we hide the notify alert bar
            if (regimeResonseData.msg === "Session Expired") {
              dispatch("clearUserLock");
            } else {
              commit("SHOW_TAX_REGIME_SELECTION_OPTION", false);
            }
          }
          resolve(regimeDetails);
        })
        .catch((retrieveTaxRegimeError) => {
          //on error we hide the notify alert bar
          commit("SHOW_TAX_REGIME_SELECTION_OPTION", false);
          //on session expire error we clear session and redirect to auth
          if (retrieveTaxRegimeError.status === 200) {
            dispatch("clearUserLock");
          }
          reject(retrieveTaxRegimeError);
        });
    });
  },

  //send the ui error log to the server
  async addErrorLog(state, error) {
    let url = window.location.href;
    const {
      clients: { apolloClientR },
    } = createProvider();
    apolloClientR.mutate({
      mutation: ADD_ERROR_LOG,
      variables: {
        errorMessage: error,
        url: url,
      },
    });
  },

  // fetch access rights for passed form
  fetchFormAccessRights(root, formName) {
    const { state } = root;
    const {
      clients: { apolloClientA },
    } = createProvider();
    return new Promise((resolve, reject) => {
      apolloClientA
        .query({
          query: CHECK_ACCESS_RIGHTS,
          variables: {
            formName: formName,
            employeeId: parseInt(state.orgDetails.employeeId),
          },
          fetchPolicy: "no-cache",
        })
        .then((response) => {
          const { errorCode, rights } = response.data.getAccessRights;
          if (!errorCode && rights) {
            resolve(rights);
          } else {
            reject("error");
          }
        })
        .catch(() => {
          reject("error");
        });
    });
  },

  // get organization subscription details
  getOrganizationSubscriptionDetails({ commit }) {
    const {
      clients: { apolloClientG },
    } = createProvider();
    return new Promise((resolve, reject) => {
      apolloClientG
        .query({
          query: GET_ORGANIZATION_SUBSCRIPTION_DETAILS,
          fetchPolicy: "no-cache",
        })
        .then((response) => {
          if (response.data) {
            let {
              getOrganizationBillingDetails: {
                errorCode,
                autoBilling,
                manualBillingDetails,
                autoBillingDetails,
              },
            } = response.data; //destructuring data
            if (!errorCode) {
              commit("UPDATE_AUTO_BILLING_FLAG", autoBilling);
              let orgBillingDetails = {
                isAutoBilling: autoBilling,
                currentStatus: "",
                demoCompleted: true,
                showPaymentAlert: false,
                isPaymentDueExceed: false,
                orgDemoPaymentDetails: {},
              };
              if (manualBillingDetails) {
                let manualBillingResponse = JSON.parse(manualBillingDetails);
                orgBillingDetails["orgDemoPaymentDetails"] =
                  manualBillingResponse;
                // if the status is present-demo-booking-card -> demo booking card present, with empty layout
                if (
                  manualBillingResponse.subscriptionAlertStatus ===
                  "present-demo-booking-card"
                ) {
                  orgBillingDetails["demoCompleted"] = false;
                }
                // if the status is present-red-payment-alert -> present red alert, with empty layout without any access.
                else if (
                  manualBillingResponse.subscriptionAlertStatus ===
                  "present-red-payment-alert"
                ) {
                  orgBillingDetails["isPaymentDueExceed"] = true;
                }
                // if the status is present-orange-payment-alert - > present alert, with accessing of the application
                else if (
                  manualBillingResponse.subscriptionAlertStatus ===
                  "present-orange-payment-alert"
                ) {
                  orgBillingDetails["showPaymentAlert"] = true;
                }
                // if autoBilling is enabled, then we can use autoBillingDetails
                if (
                  autoBilling &&
                  autoBillingDetails &&
                  !orgBillingDetails["isPaymentDueExceed"] &&
                  orgBillingDetails["demoCompleted"]
                ) {
                  let autoBillingResponse = JSON.parse(autoBillingDetails);
                  const {
                    currentStatus,
                    trialRemainingDays,
                    subscriptionStatus,
                    subscriptionId,
                    subscribedPlanQuantity,
                    subscriptionCurrency,
                    subscriptionBillingPeriod,
                    portalPlanId,
                  } = autoBillingResponse;
                  commit(
                    "UPDATE_AUTO_BILLING_PLAN_CURRENT_STATUS",
                    currentStatus
                  );
                  commit("UPDATE_SUBSCRIPTION_PLAN_STATUS", subscriptionStatus);
                  commit("UPDATE_AUTO_BILLING_DETAILS", {
                    planId: portalPlanId,
                    subscriptionId: subscriptionId,
                    subscribedPlanQuantity: subscribedPlanQuantity,
                    subscriptionCurrency: subscriptionCurrency,
                    subscriptionBillingPeriod: subscriptionBillingPeriod,
                  });
                  commit("UPDATE_TRIAL_PERIOD", trialRemainingDays);
                  orgBillingDetails["currentStatus"] = currentStatus;
                  resolve(orgBillingDetails);
                } else {
                  resolve(orgBillingDetails);
                }
              } else {
                reject();
              }
            } else {
              reject();
            }
          } else {
            reject();
          }
        })
        .catch(() => {
          reject();
        });
    });
  },

  // get the list of whole countries
  listCountries({ commit }) {
    const {
      clients: { apolloClientI },
    } = createProvider();
    return new Promise((resolve) => {
      apolloClientI
        .query({
          query: LIST_COUNTRY,
        })
        .then((response) => {
          const { errorCode, countries } = response.data.listCountries;
          if (!errorCode && countries) {
            commit("UPDATE_COUNTRIES", countries);
            resolve(countries);
          } else {
            commit("UPDATE_COUNTRIES", []);
            resolve([]);
          }
        })
        .catch(() => {
          commit("UPDATE_COUNTRIES", []);
          resolve([]);
        });
    });
  },

  // list states based on country code
  listStatesBasedOnCountry(state, payload) {
    const {
      clients: { apolloClientC },
    } = createProvider();
    return new Promise((resolve, reject) => {
      apolloClientC
        .query({
          query: GET_STATES,
          variables: {
            countryCode: payload.countryCode,
          },
        })
        .then((response) => {
          const { errorCode, listStateDetails } = response.data.listStates;
          if (!errorCode && listStateDetails) {
            resolve(listStateDetails);
          } else {
            reject("error");
          }
        })
        .catch(() => {
          reject("error");
        });
    });
  },

  // list custom group based on form name
  listCustomGroupBasedOnFormName(state, payload) {
    const {
      clients: { apolloClientC },
    } = createProvider();
    return new Promise((resolve, reject) => {
      apolloClientC
        .query({
          query: LIST_CUSTOM_GROUPS,
          variables: {
            formName: payload.formName,
          },
          fetchPolicy: "no-cache",
        })
        .then((response) => {
          const { errorCode, customGroups } =
            response.data.listCustomEmployeeGroups;
          if (!errorCode) {
            resolve(customGroups ? customGroups : []);
          } else {
            reject("error");
          }
        })
        .catch(() => {
          reject("error");
        });
    });
  },

  // clear lock to the particular record
  createCustomGroup({ commit, state }, { groupName, forms, notes, jsonQuery }) {
    const {
      clients: { apolloClientA },
    } = createProvider();
    return new Promise((resolve, reject) => {
      apolloClientA
        .mutate({
          mutation: ADD_CUSTOM_GROUP,
          variables: {
            groupName: groupName,
            forms: forms,
            notes: notes,
            jsonQuery: jsonQuery,
            employeeId: parseInt(state.orgDetails.employeeId),
          },
        })
        .then((response) => {
          const { errorCode } = response.data.createCustomGroup;
          let snackbarData = {
            isOpen: true,
            message: "",
            type: "warning",
          };
          if (!errorCode) {
            snackbarData.type = "success";
            snackbarData.message = "Custom group created successfully.";
            commit("OPEN_SNACKBAR", snackbarData);
            resolve("success");
          } else {
            snackbarData.message =
              "Something went wrong while creating the custom group. Please try after some time or talk to your platform administrator.";
            commit("OPEN_SNACKBAR", snackbarData);
            reject("");
          }
        })
        .catch((error) => {
          let commonErrMsg =
            "Something went wrong while creating the custom group. If you continue to see this issue, please contact the platform administrator.";
          let snackbarData = {
            isOpen: true,
            message: "",
            type: "warning",
          };
          if (error && error.graphQLErrors) {
            let errorCode = getErrorCodesWithValidationFromMessage(error);
            if (errorCode) {
              switch (errorCode[0]) {
                case "_DB0000": //- Technical issue
                  snackbarData.message =
                    "It's us!, There seems to be some issue. Would you mind trying it after some time or talk to your administrator?";
                  break;
                case "BAD_USER_INPUT": // if any input validation error occurs, BAD_USER_INPUT was returned as error code from backend
                case "IVE0000": // invalid input request
                  var validationErrors = errorCode[1];
                  // add all the backend validation error messages as single sentence to present it to the users
                  var validationMessages = "";
                  if (validationErrors) {
                    for (var errCode in validationErrors) {
                      // Please provide a valid group name.
                      if (errCode === "IVE0006") {
                        validationMessages = validationErrors[errCode];
                      }
                    }
                  }
                  // checking the validation message availability
                  if (validationMessages) {
                    snackbarData.message = validationMessages;
                  }
                  // other validation errors are not handled by users. So as of now it was considers as common error.
                  else {
                    snackbarData.message = commonErrMsg;
                  }
                  break;
                case "_DB0101": // This employee do not have create access rights
                  snackbarData.message =
                    "Sorry, you don't have access to create custom group. Please contact HR administrator.";
                  break;
                case "_DB0001": // Error while retrieving the employee access rights
                case "_DB0002": // Error while trying to check the employee access rights
                case "_DB0104": // While check access rights form not found'
                case "_UH0001": // unhandled error from backend
                case "ERE0016": // Error while creating the custom employee groups.
                case "ERE0116": // Error while process the request for creating the custom employee groups.
                default:
                  snackbarData.message = commonErrMsg;
                  break;
              }
            } else {
              snackbarData.message = commonErrMsg;
            }
          } else if (error && error.networkError) {
            snackbarData.message = handleNetworkErrors(error);
          }
          commit("OPEN_SNACKBAR", snackbarData);
          reject("");
        });
    });
  },

  getPlanType({ dispatch }) {
    const {
      clients: { apolloClientC },
    } = createProvider();
    return new Promise((resolve) => {
      apolloClientC
        .query({
          query: GET_SUBSCRIBED_PLAN_TYPE,
        })
        .then((response) => {
          const {
            getOrganizationSubscribedPlan: { errorCode, subscribedDashboard },
          } = response.data;
          if (!errorCode && subscribedDashboard) {
            let planType = dispatch("setPlanType", subscribedDashboard);
            resolve(planType);
          } else {
            resolve(dispatch("setPlanType"));
          }
        })
        .catch(() => {
          resolve(dispatch("setPlanType"));
        });
    });
  },

  setPlanType(state, planType = "") {
    let dashboardType = "";
    // plan type is retrieved from BE, then we can use this and also set the value in cookie
    if (planType) {
      dashboardType = planType;
      // set expiry time as 17 days from current date
      let planTypeExpiryTime = moment().add(17, "days");
      window.$cookies.set(
        "orgSubscribedPlan",
        dashboardType,
        planTypeExpiryTime.toDate().toUTCString()
      );
    }
    // when plan is not retrieved from BE(any case of error in endpoint)
    else {
      // get the plan type from cookie
      let planTypeInCookie = window.$cookies.get("orgSubscribedPlan");
      /**
       * if the plan type is already exist in cookie, then we can get that value when we get error/empty response.
       * Otherwise we can set hrms plan type as default
       */
      dashboardType = planTypeInCookie ? planTypeInCookie : "HRMSDASHBOARD";
    }
    return dashboardType;
  },

  // encrypt RefreshToken and redirect to partner page
  encryptRefreshToken({ commit }, { formURL }) {
    const {
      clients: { apolloClientA },
    } = createProvider();
    return new Promise((resolve, reject) => {
      apolloClientA
        .query({
          query: ENCRYPT_REFRESH_TOKEN,
          fetchPolicy: "no-cache",
          variables: {
            refreshToken: window.$cookies.get("refreshToken"),
          },
        })
        .then((response) => {
          const { errorCode, refreshToken } = response.data.encryptRefreshToken;
          if (!errorCode) {
            window.location.href =
              "https://" + formURL + "/?rtkn=" + refreshToken;
            resolve("");
          } else {
            let snackbarData = {
              isOpen: true,
              message:
                "Something went wrong while redirecting. Please try after some time.",
              type: "warning",
            };
            commit("OPEN_SNACKBAR", snackbarData);
            reject("error");
          }
        })
        .catch(() => {
          let snackbarData = {
            isOpen: true,
            message:
              "Something went wrong while redirecting. Please try after some time.",
            type: "warning",
          };
          commit("OPEN_SNACKBAR", snackbarData);
          reject("error");
        });
    });
  },

  // get address from google api with latitude and longitude
  getAddressFromLatLng(state, coordinates) {
    const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${coordinates.lat},${coordinates.lng}&key=${config.googleMapsAPIKey}`;
    return new Promise((resolve, reject) => {
      Vue.prototype.$http
        .get(url)
        .then((response) => {
          if (coordinates.addressType === "city") {
            resolve(response.data.results[6].formatted_address);
          } else {
            resolve(response.data.results[0].formatted_address);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  // list custom group based on form name
  s3FileUploadRetrieveAction(state, payload) {
    const {
      clients: { apolloClientA },
    } = createProvider();
    return new Promise((resolve, reject) => {
      apolloClientA
        .mutate({
          mutation: GET_PRESIGNED_URL,
          variables: payload,
          fetchPolicy: "no-cache",
        })
        .then((response) => {
          if (response.data.getPresignedUrl) {
            resolve(response.data.getPresignedUrl);
          } else {
            reject("error");
          }
        })
        .catch(() => {
          reject("error");
        });
    });
  },

  s3FileUploadRetrievalAction({ commit }, payload) {
    const {
      clients: { apolloClientA },
    } = createProvider();
    let errMsg = payload.action === "upload" ? "uploading" : "retrieving";
    errMsg =
      "Something went wrong while " +
      errMsg +
      " the file contents. Please try after some time.";
    return new Promise((resolve, reject) => {
      apolloClientA
        .mutate({
          mutation: GET_PRESIGNED_URL,
          variables: payload,
          fetchPolicy: "no-cache",
        })
        .then((response) => {
          if (response.data.getPresignedUrl) {
            const { presignedUrl, s3DocumentDetails } =
              response.data.getPresignedUrl;
            if (presignedUrl) {
              if (payload.action === "upload") {
                axios
                  .put(presignedUrl, payload.fileContent, {
                    headers: {
                      "Content-Type":
                        payload.fileContent.type || "application/octet-stream",
                      "Cache-Control": "no-cache, no-store, must-revalidate",
                    },
                  })
                  .then(() => {
                    resolve();
                  })
                  .catch(() => {
                    let snackbarData = {
                      isOpen: true,
                      message: errMsg,
                      type: "warning",
                    };
                    commit("OPEN_SNACKBAR", snackbarData);
                    reject();
                  });
              } else {
                resolve(presignedUrl);
              }
            } else {
              if (
                (payload.action === "getdata" ||
                  payload.action === "getrawdata") &&
                s3DocumentDetails
              ) {
                resolve(s3DocumentDetails);
              } else {
                let snackbarData = {
                  isOpen: true,
                  message: errMsg,
                  type: "warning",
                };
                commit("OPEN_SNACKBAR", snackbarData);
                reject();
              }
            }
          } else {
            let snackbarData = {
              isOpen: true,
              message: errMsg,
              type: "warning",
            };
            commit("OPEN_SNACKBAR", snackbarData);
            reject();
          }
        })
        .catch(() => {
          let snackbarData = {
            isOpen: true,
            message: errMsg,
            type: "warning",
          };
          commit("OPEN_SNACKBAR", snackbarData);
          reject();
        });
    });
  },

  //deleting s3 file

  deletes3File(state, payload) {
    const {
      clients: { apolloClientA },
    } = createProvider();
    return new Promise((resolve, reject) => {
      apolloClientA
        .mutate({
          mutation: DELETE_PRESIGNED_URL,
          variables: payload,
        })
        .then((response) => {
          if (response.data.deleteS3Files) {
            resolve(response.data.deleteS3Files);
          } else {
            reject("error");
          }
        })
        .catch(() => {
          reject("error");
        });
    });
  },

  // list custom group based on form name
  getEmployeesList(state, payload) {
    const {
      clients: { apolloClientI },
    } = createProvider();
    return new Promise((resolve, reject) => {
      apolloClientI
        .query({
          query: GET_EMPLOYEE_LIST,
          variables: {
            formName: payload.formName,
          },
        })
        .then((response) => {
          const { errorCode, employeeDetails } =
            response.data.getEmployeesDetailsBasedOnRole;
          if (!errorCode) {
            resolve(employeeDetails);
          } else {
            reject("error");
          }
        })
        .catch(() => {
          reject("error");
        });
    });
  },

  getDropdownDetails(state, payload) {
    let key = payload !== undefined ? payload.key : [];
    let formId = payload !== undefined ? payload.formId : null;
    let conditionDetails =
      payload !== undefined ? payload?.conditionDetails : [];
    const {
      clients: { apolloClientAC },
    } = createProvider();
    return new Promise((resolve, reject) => {
      apolloClientAC
        .query({
          query: RETRIEVE_DROPDOWN_DETAILS,
          variables: {
            key: key,
            formId: formId,
            conditionDetails: conditionDetails,
          },
          fetchPolicy: "no-cache",
        })
        .then((response) => {
          resolve(response);
        })
        .catch(() => {
          reject();
        });
    });
  },

  getAllEmployeesList(state, { formName, isActiveOnly = 1 }) {
    const {
      clients: { apolloClientC },
    } = createProvider();
    return new Promise((resolve, reject) => {
      apolloClientC
        .query({
          query: GET_ALL_EMPLOYEES,
          variables: {
            designationId: [],
            departmentId: [],
            empTypeId: [],
            workScheduleId: [],
            locationId: [],
            formName: formName,
            onlyActiveEmployees: isActiveOnly,
          },
          fetchPolicy: "no-cache",
        })
        .then((response) => {
          const { errorCode, employeeList } =
            response.data.listAllEmployeeDetails;
          if (!errorCode && employeeList) {
            resolve(employeeList);
          } else {
            reject("error");
          }
        })
        .catch((fetchError) => {
          if (fetchError && fetchError.graphQLErrors) {
            let errorCode = getErrorCodes(fetchError);
            if (errorCode) {
              switch (errorCode) {
                case "_DB0000": //- Technical error
                  reject(
                    "It’s us! There seems to be some technical difficulties while fetching the employees. Please try after some time."
                  );
                  break;
                case "DB0100": // This employee do not have view access rights
                  reject(
                    "Sorry, you don't have access rights to view the employees. Please contact HR administrator."
                  );
                  break;
                case "EM0007": // Error while listing the employees.
                case "_DB0002": // Error while checking the employee access rights
                case "_DB0104": // While check access rights form not found.
                default:
                  reject("error");
                  break;
              }
            } else {
              reject("error");
            }
          } else if (fetchError && fetchError.networkError) {
            reject(handleNetworkErrors(fetchError));
          } else {
            reject("error");
          }
        });
    });
  },

  triggerControllerFunction(state, payload) {
    const {
      clients: { apolloClientAE },
    } = createProvider();
    let encryptedPayload = encryptObject(payload);

    return new Promise((resolve, reject) => {
      apolloClientAE
        .mutate({
          mutation: TRIGGER_CONTROLLER_FUNCTION,
          fetchPolicy: "no-cache",
          variables: encryptedPayload,
        })
        .then((res) => {
          let { triggerControllerFunction } = res.data;
          if (triggerControllerFunction && triggerControllerFunction.response) {
            let response = JSON.parse(triggerControllerFunction.response);
            resolve(response);
          } else {
            reject();
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  // Sign in with Firebase custom token
  signInWithCustomToken(state, customToken) {
    return new Promise((resolve, reject) => {
      firebase
        .auth()
        .signInWithCustomToken(customToken)
        .then(() => {
          resolve();
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  // Impersonate user by employee ID
  impersonateUser({ dispatch, state, getters }, payload) {
    const {
      clients: { apolloClientAH },
    } = createProvider();

    let variables = {};
    if (payload.exitProxy) {
      variables = {
        exitProxy: true,
      };
    } else {
      variables = {
        employeeId: payload.employeeId,
        exitProxy: false,
      };
    }

    return new Promise((resolve, reject) => {
      apolloClientAH
        .mutate({
          mutation: IMPERSONATE_USER,
          variables: variables,
        })
        .then(async (response) => {
          if (
            response &&
            response.data &&
            response.data.impersonateUser &&
            !response.data.impersonateUser.errorCode
          ) {
            const customToken = response.data.impersonateUser.customToken;
            // Sign in with custom token
            await dispatch("signInWithCustomToken", customToken);
            // Notify other tabs about proxy state change by updating localStorage
            // The storage event only fires in OTHER tabs, not the current one
            localStorage.setItem("proxyStateChanged", Date.now().toString());
            resolve();
            let targetUrl = "";
            const partnerid = window.$cookies.get("partnerid"),
              orgCode = localStorage.getItem("orgCode") || getters.orgCode,
              dashboardType = state.planDashboardType,
              // If any one updating the below array updateit in shouldShowDashboard in AuthLayout.vue
              hiddenOrgCodes = [
                "ferguson",
                "fergusonglobal",
                "fergusonuat",
                "fergusonglobaluat",
                "walkthrough",
              ];

            if (partnerid?.toLowerCase() === "rise-app")
              targetUrl = "v3/my-finance/my-pay";
            else if (dashboardType === "EMPLOYEEMONITORINGDASHBOARD")
              targetUrl = "in/productivity-monitoring/activity-dashboard";
            else if (dashboardType === "RECRUITMENTDASHBOARD")
              targetUrl = "v3/recruitment/dashboard";
            else if (!hiddenOrgCodes.includes(orgCode)) targetUrl = "v3/";

            if (targetUrl) window.location.href = getters.baseUrl + targetUrl;
            else window.location.reload();
          } else {
            const errorMessage =
              response?.data?.impersonateUser?.message ||
              "Failed to impersonate user.";
            reject(new Error(errorMessage));
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  addSystemLogs(state, payload = {}) {
    const {
      clients: { apolloClientJ },
    } = createProvider();
    return new Promise((resolve, reject) => {
      apolloClientJ
        .mutate({
          mutation: ADD_SYSTEM_LOGS,
          variables: {
            ...payload,
          },
        })
        .then((response) => {
          const { message, errorCode } = response?.data?.addSystemLogs || {};
          if (!errorCode) {
            resolve({ errorCode, message });
          } else {
            reject();
          }
        })
        .catch(() => {
          reject();
        });
    });
  },
};
